import { render, staticRenderFns } from "./SettingsTabPaymentTypes.vue?vue&type=template&id=4195f6f7&scoped=true"
import script from "./SettingsTabPaymentTypes.vue?vue&type=script&lang=ts"
export * from "./SettingsTabPaymentTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4195f6f7",
  null
  
)

export default component.exports